import { ModalTriggerContext } from "@certn/cascadia/components/modal/context";
import { CascadiaModalTriggerProps } from "@certn/cascadia/components/modal/types";
import { useState } from "react";
import { DialogTrigger } from "react-aria-components";

interface Props extends CascadiaModalTriggerProps {
  isOpen?: boolean;
}

/** @deprecated Please update import to `@certn/cascadia` to add cross-platform support. See CHEESE-213 for more details. */
export function ModalTrigger(props: Props) {
  const { trigger, children, ...dialogTriggerProps } = props;

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const close = () => setIsOpen(false);

  return (
    <ModalTriggerContext.Provider value={{ toggle, isOpen, setIsOpen }}>
      <DialogTrigger
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        {...dialogTriggerProps}
      >
        {typeof trigger === "function"
          ? trigger({ toggle, isOpen, setIsOpen })
          : trigger}
        {typeof children === "function" ? children({ close }) : children}
      </DialogTrigger>
    </ModalTriggerContext.Provider>
  );
}
